import { render, staticRenderFns } from "./CulturalModal.vue?vue&type=template&id=3f13a96c&scoped=true&"
import script from "./CulturalModal.vue?vue&type=script&lang=js&"
export * from "./CulturalModal.vue?vue&type=script&lang=js&"
import style0 from "./CulturalModal.vue?vue&type=style&index=0&id=3f13a96c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f13a96c",
  null
  
)

export default component.exports